import React from 'react';
import { Image } from 'antd';
import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { PreviewToolbar } from '../../../views/SidebarPanel/Detailbar/Attachments/PreviewToolbar';
import styles from './CommentImageView.module.css';

export type CommentImagePreviewStorage = {
  getContainer?: () => HTMLElement;
};

export const CommentImageView = ({ node, extension }: NodeViewProps) => {
  const src = String(node.attrs.src || '');
  const alt = String(node.attrs.alt || '');
  if (!src) return null;

  const storage = extension.storage as CommentImagePreviewStorage;

  return (
    <NodeViewWrapper
      as="span"
      className={styles.commentImage}
      contentEditable={false}
    >
      <Image
        src={src}
        alt={alt}
        preview={{
          src,
          mask: false,
          getContainer: () => storage.getContainer?.() || document.body,
          toolbarRender: (_, info) => (
            <PreviewToolbar {...info} isImage url={src} />
          )
        }}
      />
    </NodeViewWrapper>
  );
};
